import type { TMessages } from '@/types/TMessages'

export const messages = { label: 'Доставка: ' } satisfies TMessages
